import {
  useQuery,
  useQueryClient,
  UseQueryOptions,
} from '@tanstack/react-query'
import { chargeAccountsKey } from './keys'
import { getChargeAccounts } from 'api/payment'

type Data = Awaited<ReturnType<typeof getChargeAccounts>>
type Options = Partial<
  UseQueryOptions<Data, Error, Data, typeof chargeAccountsKey>
>

export function useChargeAccounts(options?: Options) {
  return useQuery({
    queryKey: chargeAccountsKey,
    queryFn: getChargeAccounts,
    ...options,
  })
}

export function useInvalidateChargeAccounts() {
  const queryClient = useQueryClient()

  return {
    invalidate: () =>
      queryClient.invalidateQueries({ queryKey: chargeAccountsKey }),
  }
}
